import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { useOrderActionsContext } from '../../contexts/OrderActions.context';
import useSignedContractSelectors from '../../contract/hooks/useSignedContractSelectors';
import useSignOrderFlow from '../../finishFlow/useSignOrderFlow';

type SignOrderModalProps = {
  open: boolean;
  orderId: string;
  orderCode?: string;
};

const SignOrderModal = ({ open, orderId, orderCode }: SignOrderModalProps) => {
  const { translate } = useTranslation();
  const { onCloseModal } = useOrderActionsContext();
  const { shouldISign, modalContent, actionLabel } = useSignedContractSelectors();
  const { generateAndOpenContract, isGenerating } = useSignOrderFlow(orderId, shouldISign);

  return (
    <Modal
      isOpen={open}
      size="standard"
      isDismissable={!isGenerating}
      header={{ title: translate(LangEnum.ORDER_FINISH_BUTTON_LABEL, { orderCode }) }}
      onClose={onCloseModal}
      footer={{
        primaryAction: {
          label: translate(actionLabel),
          onClick: generateAndOpenContract,
          isLoading: isGenerating,
          isDisabled: isGenerating,
        },
        secondaryAction: {
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
          onClick: onCloseModal,
        },
      }}
    >
      <Typography variant="body1" color="textSecondary" sx={{ whiteSpace: 'pre-line' }}>
        {translate(modalContent)}
      </Typography>
    </Modal>
  );
};

export default SignOrderModal;
